import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import { ScreenFrame, ViewToggle } from '../PrototypeShared';
import { Inventory2 } from '@mui/icons-material';
import { EmptyState } from '../PrototypeShared';

const MOCK_STOCK = [
  { id: 'P001', location: 'A-1', rawMaterial: 'Mix KOOI 1', quantity: 20, unit: 'kg' },
  { id: 'P002', location: 'A-2', rawMaterial: 'Margarine', quantity: 15, unit: 'kg' },
];

export default function IncomingStockScreen() {
  const [view, setView] = useState('list');

  return (
    <ScreenFrame
      title="Incoming stock overview"
      actions={
        <>
          <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }]} />
          <Button component={Link} to="/prototype/incoming-deliveries" variant="outlined" size="small">Deliveries list</Button>
        </>
      }
    >
      {view === 'empty' ? (
        <EmptyState icon={Inventory2} title="No stock" description="No stock recorded yet." actionLabel="Go to deliveries" onAction={() => window.location.href = '/prototype/incoming-deliveries'} />
      ) : (
        <>
          <Typography color="text.secondary" paragraph>Stock by location. Click a row to see pallet detail (via Pallets).</Typography>
          <Paper sx={{ overflow: 'auto' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Pallet ID</TableCell>
                  <TableCell>Location</TableCell>
                  <TableCell>Raw material</TableCell>
                  <TableCell align="right">Quantity</TableCell>
                  <TableCell>Unit</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {MOCK_STOCK.map((row) => (
                  <TableRow key={row.id} hover>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>{row.location}</TableCell>
                    <TableCell>{row.rawMaterial}</TableCell>
                    <TableCell align="right">{row.quantity}</TableCell>
                    <TableCell>{row.unit}</TableCell>
                    <TableCell><Button component={Link} to={`/prototype/pallets/${row.id}`} size="small">View pallet</Button></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
    </ScreenFrame>
  );
}
